export default "__VITE_ASSET__nW2J1rRX__"